import { render, staticRenderFns } from "./MainTabContainer.vue?vue&type=template&id=900b557e"
import script from "./MainTabContainer.vue?vue&type=script&lang=js"
export * from "./MainTabContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports